import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { VaultOnboardingFormField } from './scaffolder';

export const VaultOnboardingFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'VaultOnboardingFormField',
    component: VaultOnboardingFormField,
  }),
);
